import { createContext, useContext } from 'react';
import type { AuthClient } from '@mrrmlab/auth';

/**
 * Lightweight app-level React context for things that don't belong in
 * TanStack Router or TanStack Query — right now that's just the AuthClient
 * (which is null when OIDC isn't configured). Kept separate from the
 * feature-shopping-list ApiClient context on purpose: that one is owned
 * by the feature package and can't leak back into app plumbing.
 */
export const AppAuthContext = createContext<AuthClient | null>(null);

export function useAppAuth(): AuthClient | null {
  return useContext(AppAuthContext);
}
